module.exports = __webpack_public_path__ + "static/img/slide-1-home.eef93d0.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/slider/benefits/slide-1-home.svg
// module id = fQz7
// module chunks = 1